<template>
  <div
    class="checkbox"
    :class="[mode === 'dark' ? 'dark-checkbox' : '', classes]"
  >
    <input
      type="checkbox"
      :id="id"
      :value="value"
      :checked="isChecked"
      @change="onChange"
      :disabled="isDisabled"
    />
    <label :for="id">
      <div v-if="$slots.body || title">
        <slot v-if="$slots.body" name="body" />
        <p v-else-if="title">{{ title }}</p>
      </div>
      <span>
        <Check :size="14" :stroke-width="2.5" />
      </span>
    </label>
  </div>
</template>

<script>
import { Check } from "lucide-vue-next";

export default {
  name: "Checkbox",
  props: {
    mode: String,
    id: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: true,
    },
    modelValue: {
      type: [Array, Boolean],
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
  },
  components: {
    Check,
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      } else {
        return this.modelValue === true;
      }
    },
  },
  methods: {
    onChange(event) {
      if (Array.isArray(this.modelValue)) {
        const updated = [...this.modelValue];
        if (event.target.checked) {
          if (!updated.includes(this.value)) {
            updated.push(this.value);
          }
        } else {
          const index = updated.indexOf(this.value);
          if (index !== -1) {
            updated.splice(index, 1);
          }
        }
        this.$emit("update:modelValue", updated);
      } else {
        this.$emit("update:modelValue", event.target.checked);
      }
    },
  },
};
</script>
